import React, { Component } from 'react';
import '../css/getEditFormaPago.css';
import 'whatwg-fetch';
//import { v4 as uuidv4 } from 'uuid';
//import jsSHA from "jssha";
import '../css/styles-compiled.css';


//import Cards from 'react-credit-cards';

class getInfoClient extends Component {
  constructor(){
    super();
    this.state = {
        forma_pago : [],
        tipo_forma_pago : [],
        accion :'',
        id_tarjeta_forma_pago:0,
        msg_loading :false,
        number: "",
        name: "",
        expiry: "",
        cvc: "",
        focus: "",
        sms:'',
        month:'',
        year:'',
        inicial:0
    }
  }

  handleInputFocus = (e) => {
    this.setState({ focus: e.target.name });
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({ [name]: value });
  }

  getnewformapago =()=>{
    this.setState({
      accion :'newformapago'
    })
  }
  handleChanget = (event)=>{
    this.setState({
       id_tarjeta_forma_pago: event.target.value
    });
  }
  get_Forma_Pago_Cliente =()=>{
    const url= this.props.dir_url + "webapp/getFormasPagoClient";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'formapagocliente', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          forma_pago : data[0].msg ,inicial:1
        })
      }else{
        this.setState({
          forma_pago : [] ,inicial:1
        })
      }
    })
    .catch(console.log)
  }
  get_Forma_Pago_Tipo =()=>{
    const url= this.props.dir_url + "webapp/getFormasPagotipo";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'formapagotipo', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          tipo_forma_pago : data[0].msg
        })
      }
    })
    .catch(console.log)
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }

  getupdatedefaultFormaPago =(id_forma_pago)=>{
      //if(Number(id_forma_pago)>0){
        const url= this.props.dir_url + "webapp/getupdatedefaultFormaPago";
        const token =  this.props.token
        const token_Client =  this.props.token_Client
        var obj = { accion:'updatedefaultFormaPago', token, token_Client,id_forma_pago};
        fetch(url, {
          method: 'POST',
          body: JSON.stringify(obj),
          headers:{
            'Accept':'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(res => res.json())
        .then((data) => {
          if(data[0].status==="ok"){
            this.setState({
              id_tarjeta_forma_pago : 0
            },()=>{
              //this.get_Forma_Pago_Cliente()
              this.props.get_go_to_sub("")
            })

          }

        })
        .catch(console.log)
      //}
  }
  getdeletedefaultFormaPago =(id_forma_pago,por_defecto)=>{

      const url= this.props.dir_url + "webapp/getdeletedefaultFormaPago";
      const token =  this.props.token
      const token_Client =  this.props.token_Client
      var obj = { accion:'deletedefaultFormaPago', token, token_Client,id_forma_pago,por_defecto};
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        //if(data[0].status==="ok"){
          this.get_Forma_Pago_Cliente()
        //}
      })
      .catch(console.log)
  }

  getsaveformapago =()=>{
    const id_tarjeta_forma_pago = this.state.id_tarjeta_forma_pago
    const number = this.state.number
    const name = this.state.name
    const expiry = this.state.expiry
    const cvc = this.state.cvc
    if(number===''&&number.length>4){
      this.number.focus();
      return null
    }
    if(name===''){
      this.name.focus();
      return null
    }
    if(expiry===''){
      this.expiry.focus();
      return null
    }
    if(cvc===''){
      this.cvc.focus();
      return null
    }
    const number_final = number.substring(number.length-4, number.length);
    if(Number(id_tarjeta_forma_pago)!==0){
      const url= this.props.dir_url + "webapp/getsaveformapago";
      const token =  this.props.token
      const token_Client =  this.props.token_Client
      let data = number+"(,)"+name+"(,)"+expiry+"(,)"+cvc
      var CryptoJS = require("crypto-js");
      var ciphertext = CryptoJS.AES.encrypt(data,"_RESP_"+token_Client+"_RESP_"+number_final);
      data=ciphertext.toString();
      var obj = { accion:'saveformapago', token, token_Client,id_tarjeta_forma_pago,data,number_final};
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        if(data[0].status==="ok"){
          this.setState({
            accion :''
          },()=>{
            //this.get_Forma_Pago_Cliente()
            this.props.get_go_to_sub("")
          })
          //this.get_loading(false)
        }
      })
      .catch(console.log)
      this.get_loading(true)

    }

  }
  getllenarFormaPagos =()=>{
    const forma_pago = this.state.forma_pago
    let id_forma_pago = 0
    if(forma_pago){
      forma_pago.map(pago => (
        id_forma_pago = Number(pago.por_defecto)
      ))
    }
    return (
      <React.Fragment>
      <div className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} onClick={ () => this.getupdatedefaultFormaPago(0)}>
        <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
        </div>
        <div className="cssversion_pw70 cssversion_pxh50 cssversion_contentCenter">
           <span className="span-global" >Efectivo</span>
        </div>
        <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
          {(id_forma_pago===0)?
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/7774226221582004489-128.png') } />
          :''}
        </div>
      </div>
      {(this.state.inicial===0)?
        <div className="cssversion_pw100 cssversion_pxh50 borderBottom cssversion_contentCenter" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} onClick={ () => this.getupdatedefaultFormaPago(0)}>
          <img alt="Cargando Imagen . . ." style={{"height":"50px"}} src={ require('../image/loading.gif')}/>
        </div>
        :''
      }
      {forma_pago.map(pago => (
        <div key={pago.id_forma_pago} className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} >
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter" onClick={ () => this.getdeletedefaultFormaPago(pago.id_forma_pago,pago.por_defecto)}>
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/14458160321582004493-128.png') } />
          </div>
          <div className="cssversion_pw70 cssversion_pxh50 cssversion_contentCenter" onClick={ () => this.getupdatedefaultFormaPago(pago.id_forma_pago)}>
             <span className="span-global" >Tarjeta {pago.tarjeta}</span>
          </div>
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter" onClick={ () => this.getupdatedefaultFormaPago(pago.id_forma_pago)}>
              {(Number(pago.id_forma_pago)===Number(pago.por_defecto))?
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/7774226221582004489-128.png') } />
              :''
            }
          </div>
        </div>

      )) }
      </React.Fragment>
    )
  }

  getListaFichaNuevoPago =()=>{
    /*<React.Fragment>
      <div className="grid-container-menu_list_formapago_izq">
        <div className="div_menu_1_list_formapago_izq">
            <select className="select-css_global" value={this.state.id_tarjeta_forma_pago} onChange={(e) => {this.handleChanget(e)}}>
            <option value="0">Seleccione Tipo de Tarjeta</option>
            {(tipo_forma_pago.length !== 0) ?
              tipo_forma_pago.map(tarjeta => (
                <option key={tarjeta.id_tarjeta} value={tarjeta.id_tarjeta} >{tarjeta.tarjeta}</option>
              ))
              : <React.Fragment></React.Fragment>
            }
          </select>
        </div>
        <div className="lbl_menu_2_list_formapago_izq" onClick={ () => this.getsaveformapago()}>
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') } />
        </div>
      </div>
      <div id="messages"><span style={{"color":"red"}}>{this.state.sms}</span></div>
    </React.Fragment>*/
    const tipo_forma_pago = this.state.tipo_forma_pago
    return (
      <div className="cssversion_pw100 cssversion_contentCenter" style={{"display":"flex"}}>
        <div id="PaymentForm" className="cssversion_pxw250" style={{"backgroundColor":"#FDEBD0","borderRadius": "5px"}}>
            <div style={{"padding":"2px"}}>
              <select className="select-css_global" value={this.state.id_tarjeta_forma_pago} onChange={(e) => {this.handleChanget(e)}}>
                <option value="0">Seleccione Tipo de Tarjeta</option>
                {(tipo_forma_pago.length !== 0) ?
                  tipo_forma_pago.map(tarjeta => (
                    <option key={tarjeta.id_tarjeta} value={tarjeta.id_tarjeta} >{tarjeta.tarjeta}</option>
                  ))
                  : <React.Fragment></React.Fragment>
                }
              </select>
            </div>
            <div style={{"padding":"2px"}}>
              <span className="span-global cssversion_pw80" style={{"fontSize": "9pt"}}>Número de Tarjeta</span>
              <div className="cssversion_pw100 cssversion_contentCenter" style={{"display":"flex"}}>
                <input ref={(input) => { this.number = input; }}   type="tel" name="number"  style={{"fontSize": "11pt"}}placeholder="9999 9999 9999 9999" class="visa identified cssversion_pw80 input-global red-input" onChange={this.handleInputChange}   onFocus={this.handleInputFocus}/>
              </div>
            </div>
            <div style={{"padding":"2px"}}>
              <div className="cssversion_pw100 cssversion_contentCenter" style={{"display":"flex"}}>
                <input ref={(input) => { this.name = input; }} type="text" name="name"  style={{"fontSize": "11pt"}} placeholder="Nombre del Titular" class="input-global cssversion_pw80 red-input" onChange={this.handleInputChange}   onFocus={this.handleInputFocus} />
              </div>
            </div>
            <div style={{"padding":"2px"}}>
              <span className="span-global"  style={{"fontSize": "9pt"}}>Vence</span>
              <input ref={(input) => { this.expiry = input; }}  type="tel" name="expiry" className="input-global cssversion_pxw50 red-input" placeholder="00/00" onChange={this.handleInputChange}   onFocus={this.handleInputFocus}/>
              <span className="span-global"  style={{"fontSize": "9pt"}}>Código</span>
              <input ref={(input) => { this.cvc = input; }}   type="tel" name="cvc" className="input-global cssversion_pxw50 red-input" placeholder="999" onChange={this.handleInputChange}   onFocus={this.handleInputFocus}/>
            </div>
            <div style={{"padding":"2px"}}>
              <div className="cssversion_pw80 cssversion_pxh40 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "5px","margin": "5px"}}>
                <span className="span-global-link" style={{"color":"white","fontSize":"8pt"}}>*Los datos de la tarjeta serán almacenados tomando todas las medidas necesarias de seguridad para evitar fraudes.</span>
              </div>
            </div>
            <div style={{"padding":"2px"}}>
              <button className="button-global cssversion_pw100" onClick={ () => this.getsaveformapago()}>
                Ingresar Tarjeta
              </button>
            </div>
        </div>
      </div>
    )
  }
  /*          <Cards
              cvc={this.state.cvc}
              expiry={this.state.expiry}
              focused={this.state.focus}
              name={this.state.name}
              number={this.state.number}
            />*/
  render() {
    let ficha_nueva_forma_pago
    const accion = this.state.accion
    if(accion==="newformapago"){//
      ficha_nueva_forma_pago =  <React.Fragment>{this.getListaFichaNuevoPago()}</React.Fragment>
    }
    let modal_loading
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
    return (
      <div className="cssversion_menu cssversion_colorblanco">
        <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}  onClick={ () => this.props.get_go_to_sub('')}>
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') }  />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
            <span className="span-global-link" >Elija Forma de Pago</span>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_ph100 yoverflow">
          {this.getllenarFormaPagos()}
          <div className="cssversion_pw100 cssversion_pxh50 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}}  onClick={ () => this.getnewformapago()}>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            </div>
            <div className="cssversion_pw70 cssversion_pxh50 cssversion_contentCenter">
               <span className="span-global" >Añadir Tarjeta de Crédito</span>
            </div>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') } />
            </div>
          </div>
          {ficha_nueva_forma_pago}
          {modal_loading}
          <div className="cssversion_pw100 cssversion_pxh80">
          </div>
        </div>
      </div>
    );
  }

  componentDidMount (){
    this.get_Forma_Pago_Cliente();
    this.get_Forma_Pago_Tipo();
  }
}
export default getInfoClient;
